<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import store from "@/vuex/store";

export default {
  name: "App",
  data () {
    return {
      path: ""
    }
  },
  created () {
    window.application = this;
    this.path = this.$route.path;

    // 在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store")) {
      store.replaceState(
        Object.assign(
          {},
          store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
    }
    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      console.log(JSON.stringify(store.state));
      sessionStorage.setItem("store", JSON.stringify(store.state));
    });
    
  },
  mounted () {
  },
  methods: {
  },
  watch: {
    $route (to, from) {
      this.path = to.path;
      
    }
  }
};
</script>

<style>
#app {
  background: #11121e;
  min-height: 100vh;
}
.el-table {
  -ms-flex: none !important;
  flex: none !important;
  height: max-content;
}
</style>



// WEBPACK FOOTER //
// src/App.vue